import { render, staticRenderFns } from "./PageWineRight.vue?vue&type=template&id=14965ee4"
import script from "./PageWineRight.vue?vue&type=script&lang=ts"
export * from "./PageWineRight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports